import { compiledPaths } from '@app/paths';
import { LastSelectionLoader } from '@app/routesWrappingComponents/SelectionLoader/LastSelectionLoader';
import { useParams } from 'react-router-dom';

export const PageRoot = () => {
  const { pageSlug } = useParams<{ pageSlug: string }>();

  return <LastSelectionLoader getRedirectionUrl={id => compiledPaths.PAGE_ORDER({ id, pageSlug: pageSlug! })} />;
};
